import { QUESTION_TYPE } from "./constants";

export const generateGameState = (question) => {
    const isWriting = question.questionType === QUESTION_TYPE.WRITTING;
    const wordList = question.questionType === QUESTION_TYPE.DROPDOWN ? [...new Set(question.shuffledWords)] : question.shuffledWords;
    return {
        words: wordList.map((word, index) => {
            return {
                id: `w${index + 1}`,
                data: word,
                used: false,
                isCorrect: null
            }
        }),
        idBlanks: isWriting ? null :
            question.formattedText.flat().filter(block => block.isGap).map((block) => {
                return {
                    id: block.id,
                    fill: null,
                    expected: block.data,
                    isCorrect: null,
                    tries: 0
                }
            }),
        textBlanks: !isWriting ? null :
            question.formattedText.flat().filter(block => block.isGap).map((block) => {
                return {
                    id: block.id,
                    userAnswer: null,
                    expected: block.data,
                    isCorrect: null,
                    tries: 0
                }
            })
    }
}

export const normalizeGameState = (gameState) => {
    const usedWords = gameState?.idBlanks.reduce((acc, blank) => {
        if(blank.fill !== null) {
            acc = [...acc, blank.fill];
        }
        return acc;
    }, []);

    const normalizedState = {
        ...gameState,
        words: gameState.words.map(word => {
            if(usedWords.includes(word.id)) {
                return {
                    ...word,
                    used: true
                }
            }
            return {
                ...word,
                used: false
            }
        }),
    }

    return normalizedState;
}